import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import messages from "../views/Dashboard/Dashboard.messages";
import { Col, Row } from "react-bootstrap";
import AlertDialog from "./AlertDialog";
import Notification from "./Notification";

const DashboardHeader = (props) => {
    const lng = props.intl.formatMessage;
    const { dashboardMessage, overpaidInformation, retrieveModalToggle, overpaidWizardToggle, showChatDisabledNotice } = props;

    return (
        <>
            <Row className="mb-3 g-5 pb-2 pt-0 pt-xl-3">
                <Col className='welcome-message'>
                    <h1 aria-label={lng(messages.welcome)}>{lng(messages.welcome)}</h1>
                </Col>
            </Row>
            {showChatDisabledNotice && (
                <AlertDialog
                    message={lng(messages.chatTemporarilyUnavailable)}
                    type="info"
                />
            )}
            {/* General invoice messages */}
            {typeof dashboardMessage.message !== 'undefined' && dashboardMessage.message !== '' && (
                <AlertDialog
                    message={dashboardMessage.message}
                    type={dashboardMessage.type}
                />
            )}
            {/* Overpaid information */}
            {overpaidInformation?.show && (
                <AlertDialog
                    message={<div>{lng(messages.overpaidInformation1)} <b>{overpaidInformation.account}</b> {lng(messages.overpaidInformation2)} <b>{overpaidInformation.name}</b>. {lng(messages.returnAmount)}: <b>{overpaidInformation.amount}</b>. {lng(messages.refundProcessingFee)}: <b>{overpaidInformation.fee}</b>.</div>}
                    type='success'
                />
            )}
            <Row className="g-5">
                <Notification
                    type={'secondary'}
                    title={lng(messages.retrieveInvoiceTitle)}
                    text={lng(messages.retrieveInvoiceDescription)}
                    onClickFunction={retrieveModalToggle}
                    label={lng(messages.openRetrieveInvoiceLabel)}
                    aria-label={lng(messages.openRetrieveInvoiceLabel)}
                />
                <Notification
                    title={lng(messages.returnPaymentTitle)}
                    text={lng(messages.returnPaymentDescription)}
                    onClickFunction={overpaidWizardToggle}
                    label={lng(messages.returnPaymentLabel)}
                    aria-label={lng(messages.returnPaymentLabel)}
                />
            </Row>
        </>
    )
}

DashboardHeader.propTypes = {
    'intl': PropTypes.object.isRequired,
    'dashboardMessage': PropTypes.object,
    'overpaidInformation': PropTypes.object,
    'retrieveModalToggle': PropTypes.func.isRequired,
    'overpaidWizardToggle': PropTypes.func.isRequired,
    'showChatDisabledNotice': PropTypes.bool
};

export default injectIntl(DashboardHeader);
